import { createEvent, createStore } from 'effector';

export const openModal = createEvent<{ name: string; data?: any }>('Open modal');
export const closeModal = createEvent<{ name: string }>('Close modal');

export interface IModalsState<T> {
  data: T;
  visibleState: Record<string, boolean>;
}

const initialState: IModalsState<any> = {
  data: null,
  visibleState: {},
};

const openModalHandler = (state: IModalsState<any>, payload: { name: string; data?: any }) => {
  const newState = {
    visibleState: {
      ...state.visibleState,
      [payload.name]: true,
    },
    data: payload.data || state.data,
  };
  return newState;
};

const closeModalHandler = (state: IModalsState<any>, payload: { name: string; data?: any }) => ({
  ...state,
  visibleState: { ...state.visibleState, [payload.name]: false },
  data: null,
});

const modals = createStore<IModalsState<any>>(initialState)
  .on(openModal, openModalHandler)
  .on(closeModal, closeModalHandler);

export default modals;
